'use client';

import { Spinner } from '@magicschool/spellbook';
import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface PageLoaderProps {
  children?: ReactNode;
}

export const PageLoader = ({ children }: PageLoaderProps = {}) => {
  const intl = useIntl();

  return (
    <div className="h-[75dvh] w-full grid items-center justify-center">
      <div className="flex flex-col items-center gap-2">
        <Spinner size="2xl" color="primary" text={{ loading: intl.formatMessage({ id: 'loading' }) }} />
        {children}
      </div>
    </div>
  );
};
